<template>
    <ToolButton :Editor="Editor" KnownIcon="Image" @ToolClick="Editor.chain().focus().insertImage().run()">

    </ToolButton>
</template>
<script>

import ToolButton from '@/views/components/atoms/tiptap/Predefined/Buttons/ToolButton.vue';

export default ({
    components: {
        ToolButton
    },
    props: ["Editor"]
});
</script>